<template>
  <div class="account-type">
    <div class="toolbar text-right">
      <label v-if="accountType.administrator"
      class="label label-warning label-margin">
        Client Admin
      </label>
      <label v-if="accountType.superAdministrator"
      class="label label-info label-margin">
        Admin
      </label>
    </div>
    <div class="row">
      <div class="col-sm-4">
        <h4>{{ accountType.name }}</h4>
        <p><strong>Business Use:</strong>
        {{ accountType.businessPlan ? 'Yes' : 'No' }}</p>
      </div>
      <div class="col-sm-4">
        <p><strong>Monthly Fee:</strong><br>
        {{ accountType.monthlyFee ? accountType.monthlyFee : 0 | to_dollar_amount }}</p>
        <p><strong>Annual Fee:</strong><br>
        {{ accountType.annualFee ? accountType.annualFee : 0 | to_dollar_amount }}</p>
      </div>
      <div class="col-sm-4">
        <p><strong>Driver Cost:</strong><br>
        {{ accountType.driverCost ? accountType.driverCost : 0 | to_dollar_amount }}</p>
        <p><strong>Pre-Authorisation Amount:</strong><br>
        {{ accountType.preAuth ? accountType.preAuth : 0 | to_dollar_amount }}</p>
        <div class="toolbar text-right">
          <router-link v-if="isFinanceAdmin" class="btn btn-default" :to="'/membership/plans/edit/' +  accountType.uuid">
            <span class="fa fa-edit fa-fw"></span> Edit
          </router-link>
          <button v-else disabled class="btn btn-default">
            <span class="fa fa-edit fa-fw"></span> Edit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AccountType',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'isFinanceAdmin'
    ]),
    accountType () {
      return {
        uuid: '',
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/AccountType.vue